export default __webpack_public_path__ + "static/media/AnimalPlanet.8c3c334a.svg";